import { useEffect } from "react";
import Input from "../../../form/Input";
import Select from "../../../form/select/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { transactionAddEdit } from "../../../../services/transactionService";
import DatePicker from "../../../form/DatePicker";
import Textarea from "../../../form/Textarea";
import { useMutation } from "@tanstack/react-query";

let validation = {
  amount: { required: true, message: "amount is required" },
  date: { required: true, message: "date is required" },
  paymentMethod: { required: true, message: "Payment method is required" },
  paymentType: { required: true, message: "Payment type is required" },
  paymentStatus: {
    required: true,
    message: "payment status is required",
  },
};

const ManageTransaction = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        firstName: data?.userData?.firstName,
        lastName: data?.userData?.lastName,
        email: data?.userData?.email,
      });
    }
  }, [data]);

  // const { data } = useQuery({
  //   queryKey: ["paymentMethod"],
  //   queryFn: async () => {
  //     const res = await paymentMethodList({
  //       limit: 10000,
  //     });
  //     return res?.docs;
  //   },
  // });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        firstName: val?.firstName || "",
        lastName: val?.lastName || "",
        email: val?.email || "",
        amount: val?.amount || "",
        date: val?.date || "",
        paymentMethod: val?.paymentMethod || "",
        paymentType: val?.paymentType || "",
        paymentStatus: val?.paymentStatus || "",
        message: val?.message,
        ...(data?._id && { id: data?._id }),
      };
      return await transactionAddEdit({
        ...payload,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-6">
          <Input
            label="Firstname"
            inputPlaceholder={"Enter First Name"}
            inputName="firstName"
            value={values?.firstName || ""}
            onChange={handleChange}
            isDisabled
            {...formValidate(errors, "firstName")}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Last Name"
            inputPlaceholder={"Enter Last Name"}
            inputName="lastName"
            value={values?.lastName || ""}
            onChange={handleChange}
            isDisabled
            {...formValidate(errors, "lastName")}
          />
        </div>
        <div className="relative col-span-12">
          <Input
            label="Donor Email"
            inputPlaceholder={"Enter Email"}
            inputName="email"
            value={values?.email || ""}
            onChange={handleChange}
            isDisabled
            {...formValidate(errors, "email")}
          />
        </div>
        <div className="relative col-span-4">
          <Input
            label="Donation Amount"
            inputPlaceholder={"Enter Amount"}
            inputName="amount"
            // inputType={"number"}
            value={values?.amount || ""}
            onChange={handleChange}
            {...formValidate(errors, "amount")}
          />
        </div>
        <div className="relative col-span-4">
          <DatePicker
            label={"Date"}
            placeholder={"Select date"}
            value={{
              startDate: values?.date,
              endDate: values?.date,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "date" },
              });
            }}
            {...formValidate(errors, "date")}
          />
        </div>
        {/* <div className="relative col-span-4">
          <Select
            label="Payment Method"
            placeholder="Select Payment Method"
            selectedValue={values?.paymentMethod}
            const
            dropdownData={
              data?.data?.map((item) => ({
                name: item?.name,
                value: item?.slug,
              })) || []
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "paymentMethod", value: val },
              });
            }}
            {...formValidate(errors, "paymentMethod")}
          />
        </div> */}
        <div className="relative col-span-4">
          <Select
            label="Payment Type"
            placeholder="Select Payment Type"
            selectedValue={values?.paymentType}
            dropdownData={
              [
                { name: "Credit Card", value: "credit" },
                { name: "Debit Card", value: "debit" },
              ] || []
            }
            onChange={(val) => {
              handleChange({
                target: { name: "paymentType", value: val },
              });
            }}
            {...formValidate(errors, "paymentType")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label="Payment Method"
            placeholder="Select Payment Method"
            selectedValue={values?.paymentMethod}
            dropdownData={
              [
                { name: "PayTm", value: "paytm" },
                { name: "UPI", value: "upi" },
              ] || []
            }
            onChange={(val) => {
              handleChange({
                target: { name: "paymentMethod", value: val },
              });
            }}
            {...formValidate(errors, "paymentMethod")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.paymentStatus}
            dropdownData={
              [
                { name: "Success", value: "completed" },
                { name: "Pending", value: "pending" },
                { name: "Cancelled", value: "cancelled" },
              ] || []
            }
            onChange={(val) => {
              handleChange({
                target: { name: "paymentStatus", value: val },
              });
            }}
            {...formValidate(errors, "paymentStatus")}
          />
        </div>
        <div className="relative col-span-12">
          <Textarea
            label={"Message"}
            inputPlaceholder={"Enter Message"}
            inputName="message"
            inputValue={values?.message || ""}
            onChange={handleChange}
          />
        </div>

        {/* <FileUploadSingle
            size="small"
            accept="application/pdf"
            label={"PDF Attachment"}
            placeholder="Attach PDF"
            value={values?.pdf}
            onChange={(file) =>
              handleChange({ target: { name: "pdf", value: file } })
            }
            {...formValidate(errors, "pdf")}
          /> */}
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageTransaction;
